import React, { useEffect, useState, useRef } from 'react';
import { ThemeProvider, ErrorPage } from '@avon/component-library';
import AppointmentFlow from '@avon/appointment-flow';
import { Box, CircularProgress, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import TagManager from '@avon/react-gtm-module';
import FormWrapper from './components/FormWrapper';
import Layout from './components/Layout';
import getUrlParams from './utils/getUrlParams';
import getApptId from './utils/getApptId';
import getAuthToken from './utils/getAuthToken';
import refreshAuthToken from './utils/refreshAuthToken';


// eslint-disable-next-line no-underscore-dangle
const domain = window._env_.REACT_APP_API_URL;
// eslint-disable-next-line no-underscore-dangle
// const clientSecret = window._env_.CLIENT_SECRET;
// eslint-disable-next-line no-underscore-dangle
// const clientId = window._env_.CLIENT_ID;
const channel = 'form';
const device = 'web';
// following line expects at least something of the form

const [, market, language] = window.location.pathname.match(/\/(..)\/(..)\/?/);

const tagManagerArgs = {
  gtmId: 'GTM-NS24BSX',
  dataLayer: {
    user_category: 'prospect',
    login_status: 'false', // "Logged in" Logged out
    market,
    language,
  },
};

TagManager.initialize(tagManagerArgs);

function App() {
  const {
    link,
  } = getUrlParams(window.location.search);

  const [apptData, setApptData] = useState();
  const [linkExpiredData, setLinkExpiredData] = useState();
  const mounted = useRef(true);
  const refreshTemp = useRef();
  const apptDataTemp = useRef();

  useEffect(
    () => {
      (async () => {
        const { accessToken, expiresIn = 300, refreshToken } = await getAuthToken({
          market,
          language,
        });

        // refresh the token 5 minutes before it expires
        window.setInterval(async () => {
          const {
            accessToken: newAccessToken,
            refreshToken: newRefreshToken,
          } = await refreshAuthToken({
            market,
            language,
            refreshToken: (refreshTemp && refreshTemp.current) || refreshToken,
          });
          refreshTemp.current = newRefreshToken;
          if (mounted.current && newAccessToken) {
            setApptData({
              ...apptDataTemp.current,
              accessToken: newAccessToken,
              refreshToken: newRefreshToken,
            });
          }
        }, 60000 + ((expiresIn - 300) * 1000));

        try {
          const { apptId, source, userId } = await getApptId({
            domain: `${domain}/appt/rga`,
            market,
            device,
            language,
            channel,
            link,
            accessToken,
          });

          TagManager.dataLayer({
            dataLayer: {
              apptId,
              user_id: userId ? userId.trim() : '',
              market,
              language,
              channel: source || channel,
              device,
              domain,
            },
          });
          if (mounted.current && accessToken && apptId) {
            apptDataTemp.current = { accessToken, apptId, refreshToken };
            setApptData({ accessToken, apptId, refreshToken });
          }
        } catch (e) {
          setLinkExpiredData(e.response.data);
        }
      })();

      return () => {
        mounted.current = false;
      };
    },
    [],
  );
  switch (language) {
    case 'ar':
      // set direction to rtl
      document.body.dir = 'rtl';
      break;

    case 'ru':
    case 'tl':
    case 'tr':
      // set direction to ltr
      document.body.dir = 'ltr';
      break;

    default:
      // Do nothing
      break;
  }

  const [isAgl, setIsAgl] = useState(false);
  const isNewSignup = ['EMPTY'].indexOf(market) > -1;
  const theme = useTheme();
  const isNotMobile = useMediaQuery(theme.breakpoints.up('sm'));

  const [newSignupHeader, setHeader] = useState();
  const updateStep = ({ properties: { header } }) => {
    if (header) {
      setHeader(header);
    }
  };

  return (
    <ThemeProvider market={market}>
      {(linkExpiredData
        && (
          <Layout market={market}>
            <Box style={isNewSignup ? {
              position: 'absolute',
              top: 124,
              left: '50%',
              transform: 'translateX(-50%)',
              background: '#FFF',
              // margin: '0 32px',
              width: isNotMobile ? 920 : 'calc(100% - 32px)',
              borderRadius: '12px',
              boxShadow: '0px 20px 40px rgba(0, 0, 0, 0.14)',
            } : {}}
            >
              <ErrorPage
                errorTitle={linkExpiredData.header}
                errorDescription={linkExpiredData.subHeader}
              />
            </Box>
          </Layout>
        )) || (apptData ? (
          <Layout market={market} newSignupHeader={newSignupHeader}>
            <article data-testid="appointment-flow">
              <FormWrapper
                isAgl={isAgl}
                market={market}
                newSignupHeader={newSignupHeader}
              >
                <AppointmentFlow
                  domain={`${domain}/appt/rga`}
                  market={market}
                  device={device}
                  language={language}
                  channel={channel}
                  link=" "
                  onFinish={() => {
                    window.open('', '_self', '').close();
                  }}
                  onAglCreated={() => {
                    setIsAgl(true);
                  }}
                  updateStep={updateStep}
                  {...apptData}
                />
              </FormWrapper>
            </article>
          </Layout>
      ) : (
        <Box data-testid="initial" component="div" textAlign="center" mt={50}>
          <CircularProgress color="primary" />
        </Box>
      ))}
    </ThemeProvider>
  );
}

export default App;
